export enum uploadTypes {
  FacilityInfo = 'FacilityInfo',
  OwnershipInfo = 'OwnershipInfo',
  SupplierUp = 'UpstreamSupplierInfo',
  SupplierDown = 'DownstreamSupplierInfo',
  MachineUtility = 'MachineUtility',
  VehicleUtility = 'VehicleUtility',
  RefrigeratorUtility = 'RefrigeratorUtility',
  Renewable = 'ElectricityRenewable',
  NonRenewable = 'ElectricityNonRenewable',
  Water = 'Water',
  Waste = 'Waste',
  SupplyUpstream = 'SupplyUpstream',
  SupplyDownstream = 'SupplyDownstream',
  TravelEmp = 'TravelEmp',
  TravelBusi = 'TravelBusi',
  CapitalGoodsAverage = 'CapitalGoodsAverage',
  CapitalGoodsSpecific = 'CapitalGoodsSpecific',
  AssetDownProperty = 'AssetDownProperty',
  AssetDownVehicle = 'AssetDownVehicle',
  AssetFranchise = 'AssetFranchise',
  InvestmentEquity = 'InvestmentEquity',
  InvestmentDebt = 'InvestmentDebt',
  InvestmentProjectFinance = 'InvestmentProjectFinance'
}

export type allUploadType =
  | uploadTypes.FacilityInfo
  | uploadTypes.OwnershipInfo
  | uploadTypes.MachineUtility
  | uploadTypes.VehicleUtility
  | uploadTypes.RefrigeratorUtility
  | uploadTypes.Renewable
  | uploadTypes.NonRenewable
  | uploadTypes.Water
  | uploadTypes.Waste
  | uploadTypes.SupplyUpstream
  | uploadTypes.SupplyDownstream
  | uploadTypes.TravelBusi
  | uploadTypes.TravelEmp
  | uploadTypes.CapitalGoodsAverage
  | uploadTypes.CapitalGoodsSpecific
  | uploadTypes.AssetDownProperty
  | uploadTypes.AssetDownVehicle
  | uploadTypes.AssetFranchise
  | uploadTypes.InvestmentDebt
  | uploadTypes.InvestmentEquity
  | uploadTypes.InvestmentProjectFinance
  | uploadTypes.SupplierDown
  | uploadTypes.SupplierUp | '';
